import classNames from 'classnames'

import { VertSpacerMd, VertSpacerSm, VertSpacerXS } from '@apps-common/components/layout'

interface IProps {
  bgClasses: string
  textClasses: string
  iconClasses: string
  bgSecondaryClasses: string
  textSecondaryClasses: string
  bgTertiaryClasses: string
}

export const UnitActivationCardSkeleton: React.FC<IProps> = (props) => {
  const { bgClasses, textClasses, bgSecondaryClasses, textSecondaryClasses, bgTertiaryClasses } = props

  return (
    <div className={classNames('rounded-[40px] px-5 py-4 hover:cursor-pointer animate-pulse', bgClasses)}>
      <div className='flex items-center justify-between'>
        <div
          className={classNames('h-[0.95rem] w-[70%] text-ellipsis whitespace-nowrap overflow-hidden rounded-2xl', bgSecondaryClasses)}
        />
      </div>
      <div className='flex items-center justify-between gap-[5px]'>
        <div
          className={classNames(
            'px-4 py-1 h-[25px] w-[60%] rounded-[15px] flex items-center justify-start gap-[10px] min-w-0',
            bgSecondaryClasses
          )}
        />
        <div className={classNames('w-[45px] h-[45px] rounded-[23px] flex items-center justify-center', bgSecondaryClasses)} />
      </div>
      <VertSpacerXS />
      <div className={classNames('h-[1rem] w-[80%] rounded-2xl text-ellipsis whitespace-nowrap overflow-hidden', bgSecondaryClasses)} />
      <VertSpacerSm />
      <div className={classNames('h-[0.85rem] w-[50%] rounded-2xl text-ellipsis whitespace-nowrap overflow-hidden', bgSecondaryClasses)} />
      <VertSpacerMd />
      <div
        className={classNames(
          'text-[0.9rem] flex items-center justify-between p-4 h-[30px] rounded-[15px] w-full',
          bgSecondaryClasses,
          textSecondaryClasses
        )}
      >
        <div />
        <div
          className={classNames(
            'w-[20px] h-[20px] rounded-[15px] flex items-center justify-center',
            bgTertiaryClasses,
            textSecondaryClasses
          )}
        />
      </div>
    </div>
  )
}
